import {faEuroSign} from "@fortawesome/pro-light-svg-icons/faEuroSign";
import {faBusAlt} from "@fortawesome/pro-light-svg-icons/faBusAlt";
import {faCoffee} from "@fortawesome/pro-light-svg-icons/faCoffee";
import {faCity} from "@fortawesome/pro-light-svg-icons/faCity";
import {faPlaneDeparture} from "@fortawesome/pro-light-svg-icons/faPlaneDeparture";
import {faSubway} from "@fortawesome/pro-light-svg-icons/faSubway";
import {faLandmark} from "@fortawesome/pro-light-svg-icons/faLandmark";
import {faTrees} from "@fortawesome/pro-light-svg-icons/faTrees";
import {faParking} from "@fortawesome/pro-light-svg-icons/faParking";
import {faUtensils} from "@fortawesome/pro-light-svg-icons/faUtensils";
import {faSchool} from "@fortawesome/pro-light-svg-icons/faSchool";
import {faDumbbell} from "@fortawesome/pro-light-svg-icons/faDumbbell";
import {faShoppingBasket} from "@fortawesome/pro-light-svg-icons/faShoppingBasket";
import {faGasPump} from "@fortawesome/pro-light-svg-icons/faGasPump";
import {faTaxi} from "@fortawesome/pro-light-svg-icons/faTaxi";
import {faTrain} from "@fortawesome/pro-light-svg-icons/faTrain";
import {faUniversity} from "@fortawesome/pro-light-svg-icons/faUniversity";
import {faShoppingBag} from "@fortawesome/pro-light-svg-icons/faShoppingBag";
import {faHospitalAlt} from "@fortawesome/pro-light-svg-icons/faHospitalAlt";
import Lang from "lang.js";
import messages from "../../js/messages";
import {faChild} from "@fortawesome/pro-light-svg-icons/faChild";
import {faBellSchool} from "@fortawesome/pro-light-svg-icons/faBellSchool";
import {faSchoolFlag} from "@fortawesome/pro-light-svg-icons/faSchoolFlag";
import {faHandsHoldingChild} from "@fortawesome/pro-light-svg-icons/faHandsHoldingChild";
import {faBreadLoaf} from "@fortawesome/pro-light-svg-icons/faBreadLoaf";

let lang = new Lang({ messages });

const Constants = Object.freeze({
    GOOGLE_MAPS_API_KEY: "AIzaSyDdZJYL6AiUDoF1zpUkTs5AmEFX3yc1pgU",
    HS_WALKSCORE_API: "11e7f03204af60beab195da271fa6adb",
    PLACETYPES: {
        bakery: lang.get("sites.bakery"),
        bank: lang.get("sites.bank"),
        bus_station: lang.get("sites.busstation"),
        cafe: lang.get("sites.cafe"),
        city_hall: lang.get("sites.city_hall"),
        airport: lang.get("sites.airport"),
        subway_station: lang.get("sites.subway_station"),
        museum: lang.get("sites.museum"),
        park: lang.get("sites.park"),
        parking: lang.get("sites.parking"),
        restaurant: lang.get("sites.restaurant"),
        gym: lang.get("sites.gym"),
        grocery_or_supermarket: lang.get("sites.grocery_or_supermarket"),
        gas_station: lang.get("sites.gas_station"),
        taxi_stand: lang.get("sites.taxi_stand"),
        train_station: lang.get("sites.train_station"),
        university: lang.get("sites.university"),
        shopping_mall: lang.get("sites.shopping_mall"),
        hospital: lang.get("sites.hospital"),
        preschool: lang.get("sites.preschool"),
        primary_school: lang.get("sites.primary_school"),
        secondary_school: lang.get("sites.secondary_school"),
        child_care_agency: lang.get("sites.child_care_agency"),
        school: lang.get("sites.school")
    },
    PLACEICONS: {
        bakery: faBreadLoaf,
        bank: faEuroSign,
        bus_station: faBusAlt,
        cafe: faCoffee,
        city_hall: faCity,
        airport: faPlaneDeparture,
        subway_station: faSubway,
        museum: faLandmark,
        park: faTrees,
        parking: faParking,
        restaurant: faUtensils,
        school: faSchool,
        gym: faDumbbell,
        grocery_or_supermarket: faShoppingBasket,
        gas_station: faGasPump,
        taxi_stand: faTaxi,
        train_station: faTrain,
        university: faUniversity,
        shopping_mall: faShoppingBag,
        hospital: faHospitalAlt,
        preschool: faChild,
        primary_school: faBellSchool,
        secondary_school: faSchoolFlag,
        child_care_agency: faHandsHoldingChild,
    },
    RECAPTHCA_KEY: {
        siteKey: "6LfamI8UAAAAAC3EJp2wapXy2l_a8oDhF3Fz8AWn"
    },
    DOMAIN_EXTENSIONS: {
        nl: ".nl",
        be: ".be",
        fr: ".fr",
        uk: ".co.uk",
        at: ".at",
        de: ".de",
        cw: ".cw",
        es: ".com"
    },
});

export default Constants;
